module.exports = __webpack_public_path__ + "img/login_bgd.2c606dae.png";